import {FC, Fragment, ReactNode, useEffect} from "react";
import {useRouter} from "next/router";

interface IProps {
    total: number | string
    children: ReactNode,
}

const InfiniteScroll: FC<IProps> = ({children, total}) => {
    const {query: {page: current = 1, ...query}, push: routerPush, asPath} = useRouter();
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('touchmove', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('touchmove', handleScroll);
        };
    }, [current, asPath]);
    const handleScroll = async () => {
        const {scrollTop, clientHeight, scrollHeight} = document.documentElement;
        if (scrollTop + clientHeight + 300 >= scrollHeight) {
            const currPageHandle: () => string = () => {
                if (!current) return "2"
                const finalPage: boolean = +current >= total;
                if (!finalPage) return String(+current + 1)
                return current as string
            }
            if (+current <= total) {
                await routerPush({ query: { ...query, page: currPageHandle() } }, undefined, {scroll: false, shallow: false})
            }
        }
    };

    return <Fragment>{children}</Fragment>
}

export default InfiniteScroll